<div class="yours-to-play-popup">
  <ion-row class="popup-row">
    <ion-row class="cover-image">
      <img src="{{ gameDetails?.game_tooltip_GIF_image }}" class="game-img" alt="" />
      <div class="seemore-txt" (click)="viewDetails()">See more details</div>
    </ion-row>
    <ion-row class="popup-content">
      <h3 class="cover-title">
        {{
        gameDetails &&
        gameDetails?.country_code_data &&
        gameDetails?.country_code_data?.[preferredCurrency == "CAD" ? 1 : preferredCurrency == "EUR" ? 353 : 44]
        ? gameDetails?.country_code_data?.[
        preferredCurrency == "CAD" ? 1 : preferredCurrency == "EUR" ? 353 : 44
        ]?.game_title.replace(
        "[prize_number]",
        gameInfo$?.play_count + (gameInfo$?.play_count > 1 ? " Prizes" : " Prize")
        )
        : "
        "
        }}
      </h3>
      <p class="cover-desc">
        <!-- {{
        gameDetails && gameDetails?.country_code_data && gameDetails?.country_code_data["44"]?.game_popup_details
        ? gameDetails?.country_code_data["44"]?.game_popup_details
        : ""
        }} -->
        {{ popupDetails }}
      </p>
      @if (prizeUnlockID == gameInfo$?.game_id) {
        <p class="prize_unlock_details">
          <span>Points<br />{{ gameInfo$?.total_reward }}</span><span>Credit<br />{{ gameInfo$?.total_credit
          }}</span><span>Cash<br />{{ gameInfo$?.total_cash }}</span>
        </p>
      }
      <button class="playnow-btn" (click)="playGame(gameDetails); startSpinner()">
        @if (!spinnerAnimation && proceed) {
          <span>Play now</span>
        }

        @if (spinnerAnimation && proceed) {
          <div class="spinners">
            <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="30">
            </mat-progress-spinner>
          </div>
        }
        @if (!proceed && !spinnerAnimation) {
          <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
        }
      </button>
      @if (gameDetails?.game_price) {
        <div class="bottom-wrap">
          <div class="points-txt">{{ gameDetails?.game_price }} {{('game_details_page.points_per_play' | translate) ? ('game_details_page.points_per_play' | translate) : 'points per play'}}</div>
        </div>
      }
    </ion-row>
  </ion-row>
</div>